/**
 * While downed: off their feet, bleeding out or crawling.
 *
 * True whether or not anyone can still pick them up, so a perk that softens being down helps in
 * the case that matters most, which is the one where nobody is coming.
 */

import type { EffectCondition } from '@/sim/effects/effectConditionContract';

export const WHILE_DOWNED = {
  id: 'whileDowned',
  label: 'while downed',
  holds: (moment) => moment.downed,
} as const satisfies EffectCondition;
